<template>
    <div class="faq-banner-area gray-gradient section-space--pb_90 position-relative pt-5">
        <div class="container_fl">
            <div class="row align-items-center">
                <div class="col-lg-7">
                    <div class="col-06__left">
                        <div class="section-title-wrapper section-space--mb_60 wow move-up">
                            <h2 class="section-title font-weight--light">Was wir Ihnen bieten</h2>
                            <h3 class="section-subtitle font-weight--light">
                              Nutzen Sie, die bisher unentdeckten, Möglichkeiten im Markt der Kunstbücher
                            </h3>
                        </div>
                        <div class="faq-wrapper  wow move-up">
                            <!-- accordion component -->
                            <Accordion />
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 wow move-up">
                    <div class="faq-banner__media">
                        <img src="../assets/img/banners/bookshelves.svg" class="img-fluid" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Accordion from "../components/Accordion"
    export default{
        name: 'FaqBanner',
        components: {
            Accordion
        }
    };
</script>

<style lang="scss" scoped>
@use '../assets/scss/variabls.scss' as vars;

.faq-banner-area {
  .section-subtitle {
    font-size: 28px;

    @media #{vars.$large-mobile}{
      margin-top: 10px;
      font-size: 20px;
    }
    @media #{vars.$small-mobile}{
      margin-top: 10px;
      font-size: 20px;
    }
  }
}
</style>